
import { Options, Vue } from "vue-class-component";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";

@Options({
  name: "CloseBtn",
  components: {
    SvgIcon
  },
})
export default class CloseBtn extends Vue {}
